<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import resize from '@Sys~/components/mixins/resize'

import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'

const bdcToolboxIcons = {
  line: require('@Sys~/assets/bdc-chart-toolbox/toolbox-line.svg'),
  bar: require('@Sys~/assets/bdc-chart-toolbox/toolbox-bar.svg'),
  stack: require('@Sys~/assets/bdc-chart-toolbox/toolbox-stack.svg'),
  tiled: require('@Sys~/assets/bdc-chart-toolbox/toolbox-tiled.svg'),
  table: require('@Sys~/assets/bdc-chart-toolbox/toolbox-table.svg'),
  restore: require('@Sys~/assets/bdc-chart-toolbox/toolbox-restore.svg')
}

export default {
  mixins: [resize],
  props: {
    id: {
      type: String,
      default: "chart"
    },
    name: {
      type: String,
      default: "chart"
    },
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      // default: () => {}
      required: true
    },
    isBdc: {
      type: Boolean,
      default: false
    },
    kpiType: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        // console.log('===图11111：==',val)
        const data = JSON.parse(JSON.stringify(val))
        this.setOptions(data)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },

  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      const data = JSON.parse(JSON.stringify(this.chartData))
      this.setOptions(data)
      // console.log('=图22222====',data)
    },
    setOptions(cusdata) {
      // console.log('===重置图===')
      // 专项设置
      const ids = this.id;
      const xname = this.name;
      cusdata = this.applyBdcChartStyle(JSON.parse(JSON.stringify(cusdata)))
      if (!cusdata.color) {
        cusdata.color = ['#6C9AFA', '#6BDCAF', '#FFA358', '#EA7464', '#7CCEEE', '#F7C42E', '#7F75B5', '#97A1ED', '#E4D6FE', '#359F9E', '#EFA18D', '#4AA9A8', '#D2E0FD', '#D87C7C', '#6E7F9D', '#787464', '#89AEFB']
      }

      if (cusdata.tooltip) {
        cusdata.tooltip.textStyle = Object.assign({}, cusdata.tooltip.textStyle || {}, {
          align: 'left'
        })
      }
      // 格式化yAxis
      if (cusdata.yAxis && cusdata.yAxis.length > 0) {
        // 去掉Y轴 横线
        // cusdata.yAxis = {
        //   axisLine:{
        //     show:false
        //   },
        //   axisTick:{
        //     show:false
        //   },
        // }

        if (Array.isArray(cusdata.yAxis)) {
          for (var i = 0; i < cusdata.yAxis.length; i++) {
            if (cusdata.yAxis[i].axisLabel) {
              if (cusdata.yAxis[i].axisLabel.formatter == undefined) {
                cusdata.yAxis[i].axisLabel.formatter = function (value) {
                  if (value > 10000 * 10000 * 10000 - 1) {
                    return (
                      parseFloat(value / (10000 * 10000 * 10000)).toFixed(1) +
                      " 兆"
                    );
                  } else if (value > 10000 * 10000 - 1) {
                    return (
                      parseFloat(value / (10000 * 10000)).toFixed(1) + " 亿"
                    );
                  } else if (value > 10000 - 1) {
                    return parseFloat(value / 10000).toFixed(1) + " 万";
                  } else {
                    return value;
                  }
                };
              }
            }
          }
        } else {
          if (cusdata.yAxis.axisLabel) {
            if (cusdata.yAxis.axisLabel.formatter == undefined) {
              cusdata.yAxis.axisLabel.formatter = function (value) {
                if (value > 10000 * 10000 * 10000 - 1) {
                  return (
                    parseFloat(value / (10000 * 10000 * 10000)).toFixed(1) +
                    " 兆"
                  );
                } else if (value > 10000 * 10000 - 1) {
                  return parseFloat(value / (10000 * 10000)).toFixed(1) + " 亿";
                } else if (value > 10000 - 1) {
                  return parseFloat(value / 10000).toFixed(1) + " 万";
                } else {
                  return value;
                }
              };
            }
          }
        }
      }

      // 格式化表格 和 下载
      if (cusdata.toolbox && JSON.stringify(cusdata.toolbox) !== '{}') {
        // console.log('feature1111111111',cusdata.toolbox.feature)
        if (JSON.stringify(cusdata.toolbox.feature) !== '{}') {
          if (JSON.stringify(cusdata.toolbox.feature.dataView) !== '{}') {
            cusdata.toolbox.feature.dataView.readOnly = false;
            cusdata.toolbox.feature.dataView.lang = ['数据视图', '关闭', '导出图表数据']
            cusdata.toolbox.feature.dataView.textColor = "#666"
            cusdata.toolbox.feature.dataView.optionToContent = function (opt) {
              // console.log('opt====',opt)
              var table = "";
              if (opt.xAxis[0].type != "value") {
                var axisData = opt.xAxis[0].data;//获取图形的data数组
              } else {
                var axisData = opt.yAxis[0].data;//获取图形的data数组
              }
              var series = opt.series;//获取series
              table += '<table class="bordered" id="tubiaoxiazai' + ids + '"><thead><tr>'
                + '<th> </th>';
              for (var i = 0; i < series.length; i++) {
                table += '<th>' + series[i].name + '</th>'
              }
              table += '</tr></thead><tbody>';
              for (var i = 0, l = axisData.length; i < l; i++) {
                table += '<tr>'
                  + '<td>' + axisData[i] + '</td>';
                for (var j = 0; j < series.length; j++) {
                  if (series[j].data[i]) {
                    table += '<td>' + series[j].data[i] + '</td>';
                  } else {
                    table += '<td>' + 0 + '</td>';
                  }
                }
                table += '</tr>';
              }
              return table;
            }

            cusdata.toolbox.feature.dataView.contentToOption = function (opt) {
              // console.log(xname)
              if (xname == "") {
                xname = "新文件"
              }
              /* generate workbook object from table */
              var wb = XLSX.utils.table_to_book(document.querySelector('#tubiaoxiazai' + ids))
              /* get binary string as output */
              var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
              try {
                FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), xname + '.xlsx')
              } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
              return wbout
            }
          }
        }
      }

      this.chart.setOption(cusdata, true)

    },

    applyBdcChartStyle(cusdata) {
      if (!this.isBdc) return cusdata

      if (Number(this.kpiType) === 80) {
        return this.applyBdcRetentionChartStyle(cusdata)
      }

      if (!cusdata.color) {
        cusdata.color = ['#6979F8', '#6BDCAF', '#FFA358', '#EA7464', '#7CCEEE', '#F7C42E']
      }

      const seriesIsArray = Array.isArray(cusdata.series)
      const seriesList = seriesIsArray
        ? cusdata.series
        : (cusdata.series ? [cusdata.series] : [])
      const isPieChart = seriesList.some(series => series && series.type === 'pie')

      const normalizeLegend = legend => {
        if (!legend) return
        legend.top = legend.top == null ? 0 : legend.top
        legend.left = legend.left == null ? 'center' : legend.left
        legend.itemWidth = legend.itemWidth == null ? 8 : legend.itemWidth
        legend.itemHeight = legend.itemHeight == null ? 8 : legend.itemHeight
        legend.itemGap = legend.itemGap == null ? 16 : legend.itemGap
        legend.textStyle = Object.assign({ color: '#666666', fontSize: 12 }, legend.textStyle || {})
      }

      const normalizePieLegend = legend => {
        if (!legend || legend.show === false) return
        legend.type = 'scroll'
        legend.orient = 'horizontal'
        legend.bottom = legend.bottom == null ? 0 : legend.bottom
        legend.left = 'center'
        legend.itemWidth = legend.itemWidth == null ? 8 : legend.itemWidth
        legend.itemHeight = legend.itemHeight == null ? 8 : legend.itemHeight
        legend.itemGap = legend.itemGap == null ? 16 : legend.itemGap
        legend.pageIconColor = legend.pageIconColor || '#6979F8'
        legend.pageIconInactiveColor = legend.pageIconInactiveColor || '#CCCCCC'
        legend.pageTextStyle = Object.assign({ color: '#666666', fontSize: 12 }, legend.pageTextStyle || {})
        legend.textStyle = Object.assign({ color: '#666666', fontSize: 12 }, legend.textStyle || {})
        delete legend.top
        delete legend.right
        delete legend.width
      }

      if (isPieChart) {
        if (cusdata.legend) {
          if (Array.isArray(cusdata.legend)) {
            cusdata.legend.forEach(normalizePieLegend)
          } else {
            normalizePieLegend(cusdata.legend)
          }
        } else {
          cusdata.legend = {
            show: true,
            type: 'scroll',
            orient: 'horizontal',
            bottom: 0,
            left: 'center',
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 16,
            pageIconColor: '#6979F8',
            pageIconInactiveColor: '#CCCCCC',
            pageTextStyle: { color: '#666666', fontSize: 12 },
            textStyle: { color: '#666666', fontSize: 12 }
          }
        }
      } else if (cusdata.legend) {
        if (Array.isArray(cusdata.legend)) {
          cusdata.legend.forEach(normalizeLegend)
        } else {
          normalizeLegend(cusdata.legend)
        }
      }

      const normalizeGrid = grid => {
        if (!grid) return
        if (grid.top == null) grid.top = 36
        if (grid.left == null) grid.left = 12
        if (grid.right == null) grid.right = 48
        if (grid.bottom == null) grid.bottom = 24
        if (grid.containLabel == null) grid.containLabel = true
      }

      if (cusdata.grid) {
        if (Array.isArray(cusdata.grid)) {
          cusdata.grid.forEach(normalizeGrid)
        } else {
          normalizeGrid(cusdata.grid)
        }
      }

      const normalizeAxisLabel = (axis, fontSize = 11) => {
        if (!axis) return
        axis.axisLabel = Object.assign({}, axis.axisLabel || {}, {
          color: '#666666',
          fontSize
        })
      }

      const normalizeAxisLine = axis => {
        if (!axis) return
        axis.axisLine = axis.axisLine || {}
        axis.axisLine.lineStyle = Object.assign({ color: '#E5E5E5' }, axis.axisLine.lineStyle || {})
      }

      const normalizeSplitLine = axis => {
        if (!axis) return
        axis.splitLine = axis.splitLine || { show: true }
        axis.splitLine.lineStyle = Object.assign({ color: '#F0F0F0' }, axis.splitLine.lineStyle || {})
      }

      if (cusdata.xAxis) {
        const axes = Array.isArray(cusdata.xAxis) ? cusdata.xAxis : [cusdata.xAxis]
        axes.forEach(axis => {
          normalizeAxisLine(axis)
          normalizeAxisLabel(axis, 11)
        })
      }

      if (cusdata.yAxis) {
        const axes = Array.isArray(cusdata.yAxis) ? cusdata.yAxis : [cusdata.yAxis]
        axes.forEach(axis => {
          normalizeAxisLine(axis)
          normalizeSplitLine(axis)
          normalizeAxisLabel(axis, 11)
        })
      }

      const normalizeDataZoom = dataZoom => {
        if (!dataZoom) return
        const isVerticalSlider = dataZoom.orient === 'vertical' ||
          (dataZoom.yAxisIndex != null && dataZoom.yAxisIndex !== '' &&
            (dataZoom.xAxisIndex == null || dataZoom.xAxisIndex === ''))
        if (isVerticalSlider) {
          // 横向条形图的 Y 轴 dataZoom：用 width 控制滑块厚度，高度随 grid 自适应
          if (dataZoom.width == null) dataZoom.width = 12
          delete dataZoom.height
          if (dataZoom.orient == null) dataZoom.orient = 'vertical'
          // 后端常见 left: 'left'（贴边对齐关键字，非像素值），会被卡片 overflow 裁切
          const left = dataZoom.left
          if (
            left == null || left === '' || left === 0 || left === '0' ||
            left === 'left' || left === 'Left'
          ) {
            dataZoom.left = 10
          } else if (typeof left === 'number') {
            dataZoom.left = left + 10
          } else if (typeof left === 'string' && /^\d+(\.\d+)?px$/.test(left)) {
            dataZoom.left = parseFloat(left) + 10
          }
        } else if (dataZoom.height == null) {
          dataZoom.height = 28
        }
        dataZoom.handleSize = '110%'
        dataZoom.backgroundColor = 'rgba(245, 245, 245, 0.6)'
        dataZoom.borderColor = '#E5E5E5'
        dataZoom.fillerColor = 'rgba(105, 121, 248, 0.1)'
        dataZoom.handleStyle = Object.assign({}, dataZoom.handleStyle || {}, {
          color: '#6979F8',
          borderColor: '#6979F8'
        })
        dataZoom.moveHandleStyle = Object.assign({}, dataZoom.moveHandleStyle || {}, {
          color: '#6979F8',
          borderColor: '#6979F8'
        })
        dataZoom.emphasis = dataZoom.emphasis || {}
        dataZoom.emphasis.handleStyle = Object.assign({}, dataZoom.emphasis.handleStyle || {}, {
          color: '#6979F8',
          borderColor: '#6979F8'
        })
        dataZoom.textStyle = Object.assign({}, dataZoom.textStyle || {}, { color: '#666666' })
        dataZoom.dataBackground = Object.assign({}, dataZoom.dataBackground || {})
        dataZoom.dataBackground.lineStyle = Object.assign({}, dataZoom.dataBackground.lineStyle || {}, { color: '#6979F8', width: 1 })
        dataZoom.dataBackground.areaStyle = Object.assign({}, dataZoom.dataBackground.areaStyle || {}, { color: 'rgba(0, 0, 0, 0.1)' })
        dataZoom.selectedDataBackground = Object.assign({}, dataZoom.selectedDataBackground || {})
        dataZoom.selectedDataBackground.lineStyle = Object.assign({}, dataZoom.selectedDataBackground.lineStyle || {}, { color: '#6979F8', width: 1 })
        dataZoom.selectedDataBackground.areaStyle = Object.assign({}, dataZoom.selectedDataBackground.areaStyle || {}, { color: 'rgba(105, 121, 248, 0.1)' })
      }

      if (cusdata.dataZoom) {
        if (Array.isArray(cusdata.dataZoom)) {
          cusdata.dataZoom.forEach(normalizeDataZoom)
        } else {
          normalizeDataZoom(cusdata.dataZoom)
        }
      }

      if (cusdata.toolbox && cusdata.toolbox.show !== false) {
        this.applyBdcToolboxStyle(cusdata)
      }

      this.applyBdcTooltipStyle(cusdata)

      if (isPieChart) {
        return this.applyBdcPieChartStyle(cusdata)
      }

      return cusdata
    },

    applyBdcToolboxStyle(cusdata) {
      const toolboxIcon = key => 'image://' + bdcToolboxIcons[key]
      const toolbox = cusdata.toolbox

      toolbox.orient = 'vertical'
      toolbox.right = toolbox.right == null ? 0 : toolbox.right
      toolbox.top = toolbox.top == null ? 0 : toolbox.top
      toolbox.itemSize = 20
      toolbox.itemGap = 8
      toolbox.showTitle = true
      toolbox.titleGap = 4
      toolbox.iconStyle = Object.assign({
        borderWidth: 0,
        opacity: 1
      }, toolbox.iconStyle || {})
      toolbox.emphasis = toolbox.emphasis || {}
      toolbox.emphasis.iconStyle = Object.assign({
        borderWidth: 0,
        opacity: 1
      }, toolbox.emphasis.iconStyle || {})

      toolbox.feature = toolbox.feature || {}
      const feature = toolbox.feature

      if (feature.magicType && JSON.stringify(feature.magicType) !== '{}') {
        feature.magicType.icon = Object.assign({}, feature.magicType.icon || {}, {
          line: toolboxIcon('line'),
          bar: toolboxIcon('bar'),
          stack: toolboxIcon('stack'),
          tiled: toolboxIcon('tiled')
        })
        feature.magicType.title = Object.assign({
          line: '折线图',
          bar: '柱状图',
          stack: '堆叠',
          tiled: '平铺'
        }, feature.magicType.title || {})
      }

      if (feature.dataView && JSON.stringify(feature.dataView) !== '{}') {
        feature.dataView.icon = toolboxIcon('table')
        feature.dataView.title = feature.dataView.title || '数据视图'
      }

      if (feature.restore && JSON.stringify(feature.restore) !== '{}') {
        feature.restore.icon = toolboxIcon('restore')
        feature.restore.title = feature.restore.title || '还原'
      }

      if (cusdata.grid) {
        const grids = Array.isArray(cusdata.grid) ? cusdata.grid : [cusdata.grid]
        grids.forEach(grid => {
          if (grid.right == null || grid.right === 48 || grid.right === 16) grid.right = 36
        })
      }

      return cusdata
    },

    applyBdcTooltipStyle(cusdata) {
      if (Number(this.kpiType) === 80) return cusdata
      if (!cusdata.tooltip || cusdata.tooltip.show === false) return cusdata

      cusdata.tooltip.show = true
      cusdata.tooltip.confine = cusdata.tooltip.confine != null ? cusdata.tooltip.confine : true
      cusdata.tooltip.padding = cusdata.tooltip.padding == null ? [6, 8] : cusdata.tooltip.padding
      cusdata.tooltip.backgroundColor = cusdata.tooltip.backgroundColor || 'rgba(51, 51, 51, 0.92)'
      cusdata.tooltip.borderWidth = cusdata.tooltip.borderWidth == null ? 0 : cusdata.tooltip.borderWidth
      cusdata.tooltip.extraCssText = cusdata.tooltip.extraCssText || 'border-radius:6px;box-shadow:none;'
      cusdata.tooltip.textStyle = Object.assign({
        color: '#FFFFFF',
        fontSize: 12,
        lineHeight: 18,
        align: 'left'
      }, cusdata.tooltip.textStyle || {})

      if (cusdata.tooltip.axisPointer) {
        cusdata.tooltip.axisPointer = Object.assign({}, cusdata.tooltip.axisPointer)
      }

      return cusdata
    },

    applyBdcPieChartStyle(cusdata) {
      const pieCenterY = '44%'
      const chartColors = Array.isArray(cusdata.color) ? cusdata.color : []

      const getLabelPosition = label => {
        if (!label) return null
        if (label.position) return label.position
        if (label.normal && label.normal.position) return label.normal.position
        return null
      }

      const isCenterLabel = label => {
        const position = getLabelPosition(label)
        return position === 'center' || position === 'inside'
      }

      const stripFixedLabelColor = label => {
        if (!label) return label
        const next = Object.assign({}, label)
        delete next.color
        if (next.textStyle) {
          next.textStyle = Object.assign({}, next.textStyle)
          delete next.textStyle.color
        }
        if (next.normal) {
          next.normal = Object.assign({}, next.normal)
          delete next.normal.color
          if (next.normal.textStyle) {
            next.normal.textStyle = Object.assign({}, next.normal.textStyle)
            delete next.normal.textStyle.color
          }
        }
        return next
      }

      const buildOutsideLabel = label => {
        return stripFixedLabelColor(Object.assign({
          show: true,
          position: 'outside',
          formatter: '{b}',
          fontSize: 12
        }, label || {}))
      }

      const applySliceLabelColors = series => {
        if (!Array.isArray(series.data)) return
        series.data = series.data.map((item, index) => {
          if (!item || typeof item !== 'object') return item
          const sliceColor = (item.itemStyle && item.itemStyle.color)
            || chartColors[index % chartColors.length]
          if (!sliceColor) return item

          const itemLabel = stripFixedLabelColor(item.label || {})
          itemLabel.show = itemLabel.show !== false
          itemLabel.color = sliceColor
          if (itemLabel.normal) {
            itemLabel.normal.color = sliceColor
            itemLabel.normal.textStyle = Object.assign({}, itemLabel.normal.textStyle || {}, { color: sliceColor })
          }

          return Object.assign({}, item, { label: itemLabel })
        })
      }

      const seriesIsArray = Array.isArray(cusdata.series)
      const seriesList = seriesIsArray
        ? cusdata.series.slice()
        : (cusdata.series ? [cusdata.series] : [])
      const pies = seriesList.filter(series => series && series.type === 'pie')
      if (!pies.length) return cusdata

      pies.forEach(series => {
        series.center = ['50%', pieCenterY]
        series.avoidLabelOverlap = true

        if (series.labelLine && series.labelLine.show === false) {
          // 后端显式关闭时不强制开启
        } else if (series.labelLine && series.labelLine.normal) {
          series.labelLine.normal = Object.assign({
            show: true,
            smooth: 0.2,
            length: 14,
            length2: 10
          }, series.labelLine.normal || {})
        } else {
          series.labelLine = Object.assign({
            show: true,
            smooth: 0.2,
            length: 14,
            length2: 10,
            lineStyle: { width: 1 }
          }, series.labelLine || {})
        }

        if (isCenterLabel(series.label)) {
          series.label = Object.assign({}, series.label, {
            position: 'center',
            align: 'center',
            verticalAlign: 'middle'
          })
        } else if (series.label && series.label.normal) {
          series.label.normal = buildOutsideLabel(series.label.normal)
        } else if (!series.label || series.label.show !== false) {
          series.label = buildOutsideLabel(series.label)
        }

        applySliceLabelColors(series)
      })

      this.applyBdcPieCenterGraphic(cusdata, pieCenterY)

      const legend = Array.isArray(cusdata.legend) ? cusdata.legend[0] : cusdata.legend
      if (legend && legend.show !== false && (!legend.data || !legend.data.length)) {
        const pieData = pies[0] && Array.isArray(pies[0].data) ? pies[0].data : []
        legend.data = pieData
          .map(item => (item && typeof item === 'object' ? item.name : item))
          .filter(name => name != null && name !== '')
      }

      cusdata.series = seriesIsArray ? seriesList : seriesList[0]
      return cusdata
    },

    applyBdcPieCenterGraphic(cusdata, pieCenterY) {
      const titleList = cusdata.title
        ? (Array.isArray(cusdata.title) ? cusdata.title : [cusdata.title])
        : []
      const titleObj = titleList.find(title => title && title.show !== false && title.text)
      if (!titleObj) return cusdata

      const mainStyle = Object.assign({
        fontSize: 18,
        fontWeight: 600,
        fill: '#333333',
        fontFamily: 'PingFang SC, Microsoft YaHei, sans-serif',
        lineHeight: 26
      }, titleObj.textStyle || {})
      const subStyle = Object.assign({
        fontSize: 12,
        fontWeight: 400,
        fill: '#999999',
        fontFamily: 'PingFang SC, Microsoft YaHei, sans-serif',
        lineHeight: 18
      }, titleObj.subtextStyle || {})

      const mainLineHeight = 26
      const subLineHeight = 18
      const lineGap = 10
      const blockHeight = titleObj.subtext
        ? mainLineHeight + lineGap + subLineHeight
        : mainLineHeight
      const blockTop = -blockHeight / 2

      const children = [{
        type: 'text',
        left: 'center',
        top: blockTop,
        style: {
          text: titleObj.text,
          textAlign: 'center',
          textVerticalAlign: 'top',
          font: `${mainStyle.fontWeight} ${mainStyle.fontSize}px ${mainStyle.fontFamily}`,
          fill: mainStyle.fill
        }
      }]

      if (titleObj.subtext) {
        children.push({
          type: 'text',
          left: 'center',
          top: blockTop + mainLineHeight + lineGap,
          style: {
            text: titleObj.subtext,
            textAlign: 'center',
            textVerticalAlign: 'top',
            font: `${subStyle.fontWeight} ${subStyle.fontSize}px ${subStyle.fontFamily}`,
            fill: subStyle.fill
          }
        })
      }

      const centerGraphic = {
        type: 'group',
        left: 'center',
        top: pieCenterY,
        z: 10,
        children
      }

      titleList.forEach(title => {
        title.show = false
      })

      if (Array.isArray(cusdata.graphic)) {
        cusdata.graphic.push(centerGraphic)
      } else if (cusdata.graphic) {
        cusdata.graphic = [cusdata.graphic, centerGraphic]
      } else {
        cusdata.graphic = [centerGraphic]
      }

      return cusdata
    },

    applyBdcRetentionChartStyle(cusdata) {
      // Figma RetentionDonut (532:4986): 留存率弧 #11B485，剩余弧 rgba(0,132,244,0.6)
      const retentionRateColor = '#11B485'
      const retentionRemainColor = 'rgba(0, 132, 244, 0.6)'

      cusdata.color = [retentionRateColor, retentionRemainColor]
      cusdata.backgroundColor = 'transparent'
      cusdata.legend = { show: false }

      if (cusdata.xAxis) {
        const axes = Array.isArray(cusdata.xAxis) ? cusdata.xAxis : [cusdata.xAxis]
        axes.forEach(axis => { axis.show = false })
      }

      if (cusdata.yAxis) {
        const axes = Array.isArray(cusdata.yAxis) ? cusdata.yAxis : [cusdata.yAxis]
        axes.forEach(axis => { axis.show = false })
      }

      if (cusdata.grid) {
        const grids = Array.isArray(cusdata.grid) ? cusdata.grid : [cusdata.grid]
        grids.forEach(grid => { grid.show = false })
      }

      if (cusdata.dataZoom) {
        const zooms = Array.isArray(cusdata.dataZoom) ? cusdata.dataZoom : [cusdata.dataZoom]
        zooms.forEach(zoom => { zoom.show = false })
      }

      if (cusdata.toolbox) {
        cusdata.toolbox.show = false
      }

      const seriesIsArray = Array.isArray(cusdata.series)
      const seriesList = seriesIsArray
        ? cusdata.series.slice()
        : (cusdata.series ? [cusdata.series] : [])
      const pies = seriesList.filter(series => series && series.type === 'pie')
      if (!pies.length) return cusdata

      pies.forEach(series => {
        series.center = ['50%', '50%']
        series.radius = [45, 60]
        series.startAngle = series.startAngle == null ? 90 : series.startAngle
        series.clockwise = series.clockwise !== false
        series.hoverAnimation = false
        series.avoidLabelOverlap = false
        series.itemStyle = Object.assign({ borderWidth: 0 }, series.itemStyle || {})
        series.labelLine = { show: false }
        series.emphasis = Object.assign({ scale: false, focus: 'none' }, series.emphasis || {})
        series.minAngle = 0

        if (Array.isArray(series.data) && series.data.length >= 2) {
          const rateVal = parseFloat(series.data[0].value) || 0
          const remainVal = parseFloat(series.data[1].value) || 0
          const gap = 0.55

          series.data = [
            {
              value: gap,
              itemStyle: { color: '#FFFFFF', borderWidth: 0 }
            },
            {
              value: Math.max(rateVal - gap, 0.01),
              itemStyle: { color: retentionRateColor, borderWidth: 0 }
            },
            {
              value: gap,
              itemStyle: { color: '#FFFFFF', borderWidth: 0 }
            },
            {
              value: Math.max(remainVal - gap, 0.01),
              itemStyle: { color: retentionRemainColor, borderWidth: 0 }
            }
          ]
        }
      })

      cusdata.series = seriesIsArray ? seriesList : seriesList[0]

      const labelRich = {
        rate: {
          fontSize: 18,
          fontWeight: 600,
          color: '#333333',
          lineHeight: 26,
          align: 'center',
          fontFamily: 'PingFang SC, Microsoft YaHei, sans-serif'
        },
        day: {
          fontSize: 12,
          color: '#777777',
          lineHeight: 18,
          fontWeight: 400,
          align: 'center',
          fontFamily: 'PingFang SC, Microsoft YaHei, sans-serif'
        }
      }

      if (cusdata.title) {
        const titleObj = Array.isArray(cusdata.title) ? cusdata.title[0] : cusdata.title
        const rateText = titleObj.text || ''
        const dayText = titleObj.subtext || ''

        pies.forEach(series => {
          series.label = {
            show: true,
            position: 'center',
            align: 'center',
            verticalAlign: 'middle',
            formatter: `{rate|${rateText}}\n{day|${dayText}}`,
            rich: labelRich
          }
        })

        if (Array.isArray(cusdata.title)) {
          cusdata.title = cusdata.title.map(title => Object.assign({}, title, { show: false }))
        } else {
          cusdata.title = Object.assign({}, cusdata.title, { show: false })
        }
      } else {
        pies.forEach(series => {
          series.label = Object.assign({ show: false }, series.label || {})
        })
      }

      return cusdata
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .bordered {
  width: 100%;
  border-top: 1px solid #dfe6ec;
  border-left: 1px solid #dfe6ec;
}

::v-deep .bordered th {
  padding: 7px;
  text-align: center;
  font-size: 14px;
  color: #666;
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}

::v-deep .bordered td {
  padding: 7px;
  text-align: center;
  font-size: 12px;
  color: #666;
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}

::v-deep .bordered th {
  background: rgb(238, 241, 246);
}
::v-deep .bordered td:first-child,
::v-deep .bordered th:first-child {
  border-left: none;
}

::v-deep .bordered tr:nth-of-type(2n) {
  background: #ffffff;
}
::v-deep .bordered tr:nth-of-type(2n + 1) {
  background: #f7fafc;
}
</style>
